let locales = {
    HistoryPAStates_title: 'Storia del processo di Partner Affiliati',
    HistoryPAStates_seeMore: 'vedere di più',
};

export default locales;